export class BrowserComponentState {
  scrollY: number;
  searchText: string;
}
